/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svcat_FullstackInputs */

const en_svcat_fullstack = /** @type {(inputs: Svcat_FullstackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full-Stack`)
};

const ar_svcat_fullstack = /** @type {(inputs: Svcat_FullstackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ويب متكامل`)
};

const bn_svcat_fullstack = /** @type {(inputs: Svcat_FullstackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফুল-স্ট্যাক`)
};

const de_svcat_fullstack = /** @type {(inputs: Svcat_FullstackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full-Stack`)
};

const es_svcat_fullstack = /** @type {(inputs: Svcat_FullstackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full-Stack`)
};

const fr_svcat_fullstack = /** @type {(inputs: Svcat_FullstackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full-Stack`)
};

const pt_svcat_fullstack = /** @type {(inputs: Svcat_FullstackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full-Stack`)
};

const zh_svcat_fullstack = /** @type {(inputs: Svcat_FullstackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全栈`)
};

const tr_svcat_fullstack = /** @type {(inputs: Svcat_FullstackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full-Stack`)
};

const ru_svcat_fullstack = /** @type {(inputs: Svcat_FullstackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full-Stack`)
};

const pl_svcat_fullstack = /** @type {(inputs: Svcat_FullstackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full-Stack`)
};

/**
* | output |
* | --- |
* | "Full-Stack" |
*
* @param {Svcat_FullstackInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svcat_fullstack = /** @type {((inputs?: Svcat_FullstackInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svcat_FullstackInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svcat_fullstack(inputs)
	if (locale === "bn") return bn_svcat_fullstack(inputs)
	if (locale === "de") return de_svcat_fullstack(inputs)
	if (locale === "es") return es_svcat_fullstack(inputs)
	if (locale === "fr") return fr_svcat_fullstack(inputs)
	if (locale === "pt") return pt_svcat_fullstack(inputs)
	if (locale === "zh") return zh_svcat_fullstack(inputs)
	if (locale === "tr") return tr_svcat_fullstack(inputs)
	if (locale === "ru") return ru_svcat_fullstack(inputs)
	if (locale === "pl") return pl_svcat_fullstack(inputs)
	return en_svcat_fullstack(inputs)
});